import { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { buildErrorMessage } from '@constants'
import { AxiosError } from 'axios'
import { Download } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { ListItem, ListItemText } from '@mui/material'
import { storeyToLabel } from '@editor/pages/Plans/components/AddPlanDialog/components/utils'
import { useMutation } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { downLoadFile } from '@utils'
import { postDownloadPositionPlanDxf } from '@mutations'
import { positionPlanDxfFilename } from '../../utils'

interface Props {
  storey: string
}

const SingleStoreyPositionPlanDxfItem = ({ storey }: Props): ReactElement => {
  const { enqueueSnackbar } = useSnackbar()
  const { projectId } = useParams()

  const storeyLabel = storeyToLabel(storey)

  const { isLoading, mutate } = useMutation(
    () => postDownloadPositionPlanDxf.request(projectId as string, [storey]),
    {
      onSuccess: (data: Blob) => {
        downLoadFile(data, 'application/dxf', positionPlanDxfFilename([storey]))
        enqueueSnackbar('DXF wurde heruntergeladen', { variant: 'success' })
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Herunterladen des DXF'), {
          variant: 'error',
        })
      },
    },
  )

  return (
    <ListItem>
      <ListItemText primary={storeyLabel} />
      <LoadingButton
        variant="outlined"
        size="small"
        loading={isLoading}
        onClick={() => mutate()}
        data-cy={`button-position-plan-dxf-${storey}`}
      >
        <Download fontSize="small" />
      </LoadingButton>
    </ListItem>
  )
}

export default SingleStoreyPositionPlanDxfItem
